/**
 * Beyond Learning Paths enums based on Docebo Learning Path
 * Used for navigating to learning path page.
 */
export enum Learning_Path {
  SYSTEM_ADMINISTRATOR = 'System Administrator',
  DEVELOPER = 'Developer',
  BUSINESS_USER = 'Business User',
  AGENT = 'Agent',
  AI_ESSENTIALS = 'AI Essentials',
}
